import React from "react";
import SupplierBalanceReport from "./SupplierBalanceReport";

const SupplierPayable = () => <SupplierBalanceReport mode="payable" />;

export default SupplierPayable;
